exports.getUser = () => {
    try {
        let user = localStorage.getItem("user");
        if (user) {
            return JSON.parse(user);
        } else {
            return null
        }
    } catch (error) {
        return null
    }
}


exports.isLoggedIn = () =>{
    let user = exports.getUser();
    if(user){
        return true
    }else{
        return false;
    }
}

exports.getUserName = () =>{
    let user = exports.getUser();
    if(user){
        let name =user?.fullName || "";
        if(user?.lname){
            name = name+" "+user?.lname
        }
        return name
    }else{
        return "";
    }
}